
import { Card } from "@/components/ui/card";

export const ApiEndpoints = () => {
  const baseUrl = "https://njptyhavlbdhmdbvyfdx.supabase.co/functions/v1";

  return (
    <div className="space-y-6">
      <div className="mb-6">
        <h3 className="font-semibold text-lg mb-2">Base URL:</h3>
        <Card className="p-4 bg-gradient-to-r from-pink-50 to-purple-50">
          <pre className="text-sm font-mono break-all">
            {baseUrl}
          </pre>
        </Card>
      </div>

      <h3 className="font-semibold text-lg">API Endpoints:</h3>
      
      <div className="space-y-4">
        <Card className="p-4">
          <h4 className="font-medium mb-2">Send SMS</h4>
          <div className="space-y-2">
            <div className="flex items-center space-x-2">
              <span className="bg-green-500 text-white px-2 py-1 rounded text-sm">POST</span>
              <pre className="bg-gray-100 p-2 rounded-lg text-sm flex-1">
                {`${baseUrl}/send-sms`}
              </pre>
            </div>
            
            <div className="mt-4">
              <h5 className="text-sm font-medium mb-2">Request Body:</h5>
              <pre className="bg-gray-100 p-4 rounded-lg text-sm">
{`{
  "to": "+1234567890",       // Recipient's phone number
  "content": "Your message", // Message content
  "from": "+1987654321",    // Optional: Sender's phone number
  "callback_url": "https://your-domain.com/webhook",  // Optional: Webhook URL
  "encrypted": false        // Optional: Whether to encrypt the message
}`}
              </pre>
            </div>

            <div className="mt-4">
              <h5 className="text-sm font-medium mb-2">Response (200 OK):</h5>
              <pre className="bg-gray-100 p-4 rounded-lg text-sm">
{`{
  "data": {
    "id": "msg_123abc",
    "status": "sent",
    "content": "Your message",
    "created_at": "2024-02-08T20:31:00Z"
  },
  "status": "success",
  "message": "Message sent successfully"
}`}
              </pre>
            </div>

            <div className="mt-4">
              <h5 className="text-sm font-medium mb-2">Error Responses:</h5>
              <div className="space-y-2">
                <div>
                  <span className="text-sm font-medium">400 Bad Request:</span>
                  <pre className="bg-gray-100 p-4 rounded-lg text-sm mt-1">
{`{
  "status": "error",
  "message": "Invalid phone number format"
}`}
                  </pre>
                </div>
                
                <div>
                  <span className="text-sm font-medium">401 Unauthorized:</span>
                  <pre className="bg-gray-100 p-4 rounded-lg text-sm mt-1">
{`{
  "status": "error",
  "message": "Invalid or missing API key"
}`}
                  </pre>
                </div>

                <div>
                  <span className="text-sm font-medium">500 Internal Server Error:</span>
                  <pre className="bg-gray-100 p-4 rounded-lg text-sm mt-1">
{`{
  "status": "error",
  "message": "Internal server error occurred"
}`}
                  </pre>
                </div>
              </div>
            </div>
          </div>
        </Card>

        <Card className="p-4">
          <h4 className="font-medium mb-2">Check Message Status</h4>
          <div className="space-y-2">
            <div className="flex items-center space-x-2">
              <span className="bg-blue-500 text-white px-2 py-1 rounded text-sm">GET</span>
              <pre className="bg-gray-100 p-2 rounded-lg text-sm flex-1">
                {`${baseUrl}/sms-status/:messageId`}
              </pre>
            </div>
            
            <div className="mt-4">
              <h5 className="text-sm font-medium mb-2">Response (200 OK):</h5>
              <pre className="bg-gray-100 p-4 rounded-lg text-sm">
{`{
  "data": {
    "id": "msg_123abc",
    "status": "delivered",
    "delivered_at": "2024-02-08T20:31:00Z"
  },
  "status": "success"
}`}
              </pre>
            </div>
          </div>
        </Card>

        <Card className="p-4">
          <h4 className="font-medium mb-2">Authentication</h4>
          <p className="text-sm text-gray-600 mb-2">
            All API requests require authentication using an API key in the HTTP header:
          </p>
          <pre className="bg-gray-100 p-4 rounded-lg text-sm">
{`x-api-key: your_api_key_here`}
          </pre>
          <p className="text-sm text-gray-600 mt-2">
            Get your API key from the API Keys section in your dashboard.
          </p>
        </Card>

        <Card className="p-4">
          <h4 className="font-medium mb-2">Request Examples</h4>
          <div className="space-y-4">
            <div>
              <h5 className="text-sm font-medium mb-2">cURL:</h5>
              <pre className="bg-gray-100 p-4 rounded-lg text-sm overflow-x-auto">
{`curl -X POST ${baseUrl}/send-sms \\
  -H "Content-Type: application/json" \\
  -H "x-api-key: your_api_key_here" \\
  -d '{
    "to": "+1234567890",
    "content": "Hello from API!"
  }'`}
              </pre>
            </div>
            
            <div>
              <h5 className="text-sm font-medium mb-2">JavaScript:</h5>
              <pre className="bg-gray-100 p-4 rounded-lg text-sm overflow-x-auto">
{`fetch("${baseUrl}/send-sms", {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
    "x-api-key": "your_api_key_here"
  },
  body: JSON.stringify({
    to: "+1234567890",
    content: "Hello from API!"
  })
})`}
              </pre>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};
